






































































































































import Vue from 'vue';
import {TicketCategoryApi} from '@/api/category-api';
import {TicketCategory} from '@/types/ticket-category';
import {TimeInterval} from '@/types/time-interval';
import PicDateTimeInterval from '@/components/PicDateTimeInterval.vue';
import PlayerConfigEdit from '@/components/PlayerConfigEdit.vue';
import {CameraToTicketCategoryClass} from '@/types/CameraToTicketCategoryClass';
import {EventType} from '@/types/event-type';
import moment from 'moment';
import {Camera} from '@/types/camera-type';
import {PlayerConfigApi} from '@/api/player-config-api';
import {PlayerConfig} from '@/types/player-config';
import ActionConfirmation from '@/components/ActionConfirmation.vue';

let eventId: string;

export default Vue.extend({
  name: 'TicketCategoryList',
  components: {PicDateTimeInterval, PlayerConfigEdit, ActionConfirmation},
  props: {
    cameras: {type: Array, required: true},
    event: {type: Object, required: true}
  },
  beforeMount() {
    eventId = this.$route.params.eventId;
    this.getData();
  },
  data() {
    return {
      categories: [] as TicketCategory[],
      panel: undefined as undefined | number,
      cameraResolution: {
        FLAT_VIDEO: ['360', '720', '960', '1080', '1440', '4k'],
        VR_VIDEO: ['SD', 'HD', 'FHD', '2,7K', '4K']
      } as { [type: string]: string[] },
      playerConfigEdit: false,
      playerConfig: {} as PlayerConfig,
      isShowConfirm: {show: false, action: () => null, actionData: null, text: ''},
    };
  },
  computed: {
    camerasPrepared(): any[] {
      return this.cameras.map(c => ({text: (c as any).title, value: (c as any).id}));
    },
    eventStart(): string {
      return moment(this.event.tsStart).format('YYYY-MM-DD HH:mm');
    },
    eventEnd(): string {
      return moment(this.event.tsEnd).format('YYYY-MM-DD HH:mm');
    }
  },
  methods: {
    async getData() {
      this.categories = await TicketCategoryApi.getListByEvent(eventId).then(res => res.data);

      if (this.categories.length) {
        let categoryToCameraMap = {} as { [ticketCategoryId: string]: CameraToTicketCategoryClass[] };

        this.categories.forEach(cat => this.$set(cat, 'cameraToTicketCategory', []));

        const camerasToCategory = await TicketCategoryApi.getBulkCameras(this.categories.map(c => c.id))
          .then(res => res.data.forEach(i => {

            if (categoryToCameraMap[i.ticketCategoryId]) {
              categoryToCameraMap[i.ticketCategoryId].push(i);
            } else {
              categoryToCameraMap[i.ticketCategoryId] = [i];
            }

          }));

        this.categories.forEach(cat => {
          if (categoryToCameraMap[cat.id]) {
            cat.cameraToTicketCategory = cat.cameraToTicketCategory.concat(categoryToCameraMap[cat.id]);
          }
        });
      }
      this.onCategoryChange();
    },
    deleteCategory(index: number) {
      this.isShowConfirm.show = false;
      const category = this.categories.splice(index, 1);
      TicketCategoryApi.delete(category[0].id);
      this.onCategoryChange();
    },
    showConfirm(event: Event, data: { text: string, action: any, actionData: any }) {
      event.stopImmediatePropagation();
      this.isShowConfirm.text = data.text;
      this.isShowConfirm.action = data.action;
      this.isShowConfirm.actionData = data.actionData;
      this.isShowConfirm.show = true;
    },
    async addCategory() {
      this.categories.push(new TicketCategory(eventId, 'Новая категория ' + this.categories.length));
      this.panel = this.categories.length - 1;
      await TicketCategoryApi.save(this.categories[this.categories.length - 1]);
      this.onCategoryChange();
    },
    async editCategory(ind: number) {
      if (this.isCategoryNameUnique(this.categories[ind])) {
        return;
      }
      await TicketCategoryApi.edit(this.categories[ind].id, this.categories[ind]);
      this.$store.commit('setMessage', {show: true, text: 'Изменения сохранены'});
    },
    async editPlayerConfig(categoryIndex: number) {
      this.playerConfig = await PlayerConfigApi.getByTicketCategory(this.categories[categoryIndex].id).then(res => res.data);
      this.playerConfigEdit = true;
    },
    async savePlayerConfig(playerConfigApi: PlayerConfig) {
      this.playerConfigEdit = false;
      await PlayerConfigApi.save(playerConfigApi);
      this.$store.commit('setMessage', {show: true, text: 'Изменения сохранены'});
    },
    isCategoryNameUnique(cat: TicketCategory) {
      if (this.categories.some(c => c.id != cat.id && c.title == cat.title)) {
        this.$store.commit('setMessage', {show: true, text: 'Категория с таким названием уже существует'});
        return true;
      }
      return false;
    },
    addTimeInterval(i: number) {
      const t = new TimeInterval();
      t.ticketCategory = this.categories[i].id;
      t.tsStart = this.event.tsStart;
      t.tsEnd = this.event.tsEnd;

      if (!this.categories[i].timeIntervals) {
        this.$set(this.categories[i], 'timeIntervals', []);
      }
      this.categories[i].timeIntervals.push(t);
    },
    saveInterval(interval: TimeInterval, timeIndex: number, catIndex: number) {
      if (this.checkDateInterval(interval, this.event)) {
        this.categories[catIndex].timeIntervals[timeIndex] = interval;
        this.editCategory(catIndex);
      } else {
        this.$store.commit('setMessage', {show: true, text: 'Промежуток времени выходит за диапазон мероприятия'});
      }
    },
    checkDateInterval(interval: TimeInterval, event: EventType) {
      return moment(this.event.tsStart).isSameOrBefore(interval.tsStart)
        && moment(interval.tsEnd).isSameOrBefore(this.event.tsEnd)
        && moment(interval.tsStart).isBefore(interval.tsEnd);
    },
    deleteInterval(interval: TimeInterval, timeIndex: number, catIndex: number) {
      this.categories[catIndex].timeIntervals.splice(timeIndex, 1);
      this.editCategory(catIndex);
    },
    addBroadcast(categoryIndex: number) {
      const cameraToTicketCategory = new CameraToTicketCategoryClass(
        (this.cameras[0] as Camera).id,
        this.categories[categoryIndex].id,
        this.cameraResolution[this.event.streamType][0]
      );

      this.categories[categoryIndex].cameraToTicketCategory.push(cameraToTicketCategory);
    },
    async setCameras(e: string, categoryIndex: number, cameraIndex: number) {
      this.categories[categoryIndex].cameraToTicketCategory[cameraIndex].cameraId = e;
      const cameraToTicketCategory = this.categories[categoryIndex].cameraToTicketCategory;

      await TicketCategoryApi.deleteCameras(this.categories[categoryIndex].id);
      await TicketCategoryApi.addCameras(cameraToTicketCategory);
      this.onCategoryChange();
    },
    async setResolution(e: string, categoryIndex: number, cameraIndex: number) {
      this.categories[categoryIndex].cameraToTicketCategory[cameraIndex].resolution = e;
      const cameraToTicketCategory = this.categories[categoryIndex].cameraToTicketCategory;

      await TicketCategoryApi.deleteCameras(this.categories[categoryIndex].id);
      await TicketCategoryApi.addCameras(cameraToTicketCategory);
      this.onCategoryChange();
    },
    onCategoryChange() {
      this.$emit('change', this.categories);
    },
    async deleteCamera(categoryIndex: number, cameraIndex: number) {

      this.categories[categoryIndex].cameraToTicketCategory.splice(cameraIndex, 1);
      const cameraToTicketCategory = this.categories[categoryIndex].cameraToTicketCategory;

      await TicketCategoryApi.deleteCameras(this.categories[categoryIndex].id);
      await TicketCategoryApi.addCameras(cameraToTicketCategory);

      this.onCategoryChange();
    }
  }
});
